export default {
    apiKey: "AIzaSyBkEPm-mbZysSNpTHYkkMD00RTDAT1USZo",
    authDomain: "payments-dev-afee5.firebaseapp.com",
    databaseURL: "https://payments-dev-afee5.firebaseio.com",
    projectId: "payments-dev-5adb2",
    storageBucket: "payments-dev-5adb2.appspot.com",
    messagingSenderId: "983871369041",
    appId: "1:983871369041:web:3f48c1471db510a34ead70"
};
